import {dbParent, insertMultiple, listAllCollection} from './utils';
import firebase from 'firebase';
import dayjs from 'dayjs';
import {createUser} from './users';


const token = sessionStorage.getItem('invite_token');
const projectId = sessionStorage.getItem('invite_project');

const getDemoProject = async () => {
  const response = await dbParent().where('isDemo', '==', true).get();
  const projects = [];
  let project_id = null;

  await response.forEach((subDoc) => {
    projects.push({...subDoc.data()});
    project_id = subDoc.id;
  });

  return {
    project: projects[0],
    project_id,
  };
};

const createDemo = async (data) => {
  const currentUser = firebase.auth().currentUser;

  return await firebase.firestore().collection('projects').add({
    ...data,
    isDemo: false,
    owner: currentUser.uid,
    start_date: dayjs(dayjs().utc().format('YYYY-MM-DD')).unix(),
    end_date: dayjs(dayjs().utc().add(14, 'days').format('YYYY-MM-DD')).unix(),
    rules: {
      [firebase.auth().currentUser.uid]: 'admin',
    },
  });
};

const getInviteEmail = async () => {
  const path = firebase.firestore().collection('invites');
  const data = await path
    .where('hash', '==', token)
    .where('projectId', '==', projectId)
    .get();

  if(data.size === 0) {
    return null
  }

  let email = null;

  data.forEach((subDoc) => {
    const subDocData = subDoc.data();
    email = subDocData.email;
  })

  return email;
}

export const getDemoUser = async (id) => {
  try {
    const data = await firebase.firestore()
      .collection('projects')
      .where('owner', '==', id)
      .where('disableDate', '==', true)
      .get();

    let project_id = null

    data.forEach((subDoc) => {
      project_id = subDoc.id;
    });

    const user = await firebase.firestore()
      .collection('projects')
      .doc(project_id)
      .collection('users')
      .where('uid', '==', id).get();

    let result = null;

    user.forEach((subDoc) => {
      result = subDoc.data();
    });

    return result;
  } catch (e) {
    return  {
      name: '',
      phone: '',
      company: '',
    }
  }
};


export const copyDemoProject = async ({phone, company, name}) => {
  const demo = await getDemoProject();
  const currentUser = firebase.auth().currentUser;
  const create_demo = await createDemo(demo.project);
  const demo_id = demo.project_id;

  await createUser(create_demo.id, {
    uid: currentUser.uid,
    position: '',
    name,
    isInvited: await getInviteEmail() === currentUser.email,
    email: currentUser.email,
    phone: phone,
    company: company,
    role: 'admin',
  });

  const project = dbParent().doc(create_demo.id);
  const objects = await listAllCollection('objects', demo_id);

  let jobs = await listAllCollection('jobs', demo_id);
  let reports = await listAllCollection('reports', demo_id);
  const new_objects = await insertMultiple(objects, project.collection('objects'), 'parentId');

  const works_type = await listAllCollection('works_type', demo_id);
  const new_works_type = await insertMultiple(works_type, project.collection('works_type'));

  const tasks_categories = await listAllCollection('tasks-categories', demo_id);
  const new_tasks_categories = await insertMultiple(tasks_categories, project.collection('tasks-categories'));

  const tasks = await listAllCollection('tasks', demo_id);
  const new_tasks= await insertMultiple(tasks, project.collection('tasks'));

  const documentation = await listAllCollection('documentation', demo_id);
  const new_documentation = await insertMultiple(documentation, project.collection('documentation'));

  const files = await listAllCollection('files', demo_id);
  const new_files = await insertMultiple(files, project.collection('files'));

  const copyIdsForJob = (job) => {
    job.objects = job.objects.map((obj) => {
      if (new_objects[obj]) {
        return new_objects[obj];
      }
      return obj;
    });
    if (job.work_type) {
      job.work_type = new_works_type[job.work_type];
    }
    return job;
  };

  const n_jobs = jobs.map((job) => copyIdsForJob(job));

  const new_jobs = await insertMultiple(n_jobs, project.collection('jobs'));

  reports = reports.map((report) => {
    report.jobs_ids = report.jobs_ids.map((job) => {
      if (job) {
        return new_jobs[job];
      }
      return job;
    });

    if (report.object && report.object.id) {
      report.object.id = new_objects[report.object.id] || null;
    }

    Object.entries(report.jobs).forEach((j, index) => {
      if (Array.isArray(report.jobs[j[0]])) {
        report.jobs[j[0]] = report.jobs[j[0]].map((job) => {
          job.job = copyIdsForJob(job.job);
          if (job.job.id) {
            job.job.id = new_jobs[job.job.id];
          }
          return job;
        });
      } else {
        report.jobs[j[0]].job = copyIdsForJob(report.jobs[j[0]].job);
        if (report.jobs[j[0]].job.id) {
          report.jobs[j[0]].job.id = new_jobs[report.jobs[j[0]].job.id];
        }
      }
    });

    return report;
  });

  const users = await listAllCollection('users', demo_id);

  await insertMultiple(
    users.filter((user) => user.isDemo === true),
    project.collection('users'),
  );
  await insertMultiple(reports, project.collection('reports'));
};



// WEBPACK FOOTER //
// ./src/firestore/demo.js